<template>
    <div>
        <b-button v-b-popover.hover.bottom="'Add manifest to cart'" @click="addManifestToCart()" v-if="!cartCheck"
            variant="outline-primary" class="mx-2 img-icon img-icon-cart-add-9" size="sm"></b-button>
        <b-button v-b-popover.hover.bottom="'Remove manifest from cart'" @click="removeManifestToCart()" v-if="cartCheck"
            variant="outline-danger" class="mx-2 img-icon img-icon-cart-remove-9" size="sm"></b-button>
    </div>
</template>

<script>

import { EntityId } from '#/protobuf/general_pb';
import { ManifestGetSession } from '#/services/manifests/get';

export default {
  props: {
    manifestId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      session: new ManifestGetSession(this.manifestId),
    };
  },
  created() {
      console.log(this.manifestId);
    return this.session.load();
  },
  computed: {
    entitiesList() {
      if (this.session.manifest) {
        return this.session.manifest.getEntitiesList();
      }
      return [];
    },
    jobsList() {
      if (this.session.manifest) {
        return this.session.manifest.getJobsList();
      }
      return [];
    },
    manifestIds() {
      if (this.session.manifest) {
        return this.session.manifest.getJobsList().concat(this.session.manifest.getEntitiesList()).map((item) => item.toObject());
      }
      return [];
    },
    uniqueIds() {
      return this.manifestIds.map((item) => {
        if (item.checksum) {
          const entityId = new EntityId();
          entityId.setSize(item.size);
          entityId.setChecksum(item.checksum);
          return entityId.toString();
        }
        return item.jobId.toString();
      });
    },
    ids() {
      return this.$store.getters['datacart/cartIds'];
    },
    cartCheck() {
      if (this.ids.length === 0) {
        return false;
      } else {
        return this.uniqueIds.filter((item) => this.ids.includes(item)).length === this.uniqueIds.length;
      }
    },
  },
  methods: {
    addManifestToCart() {
        console.log(this.jobsList);
      const items = this.entitiesList.concat(this.jobsList);
      console.log('items', items);
      for (let i = 0; i < items.length; i += 1) {
        this.$store.dispatch('datacart/addToCart', items[i].toObject());
      }
    },
    removeManifestToCart() {
      for (let i = 0; i < this.uniqueIds.length; i += 1) {
        this.$store.dispatch('datacart/removeFromCart', { id: this.uniqueIds[i] });
      }
    },
  },
};
</script>
<style scoped>
.addRemoveBtn{
  display: block;
  position: relative;
  top: 30px;
  right: 15px;
  z-index: 1;
  left: 421px;
}
</style>
